/* eslint-disable */
import MobxReactForm from 'mobx-react-form';
import dvr from 'mobx-react-form/lib/validators/DVR';
import validatorjs from 'validatorjs';
export const fields = [
    {
        name: 'discountCode',
        label: 'CheckoutPage:orderOverview.discountCode',
        rules: 'discount_code|max:30',
        value: ''
    },
    {
        name: 'verjaehrungsfrist',
        label: 'CheckoutPage:orderOverview.verjaehrungsfristLabel',
        type: 'checkbox',
        rules: 'accepted',
        value: false
    },
    {
        name: 'aktualisierung',
        label: 'CheckoutPage:orderOverview.aktualisierungLabel',
        type: 'checkbox',
        rules: 'accepted',
        value: false
    }
];
const hooks = {
    onSuccess: () => { },
    onError(form) {
        console.log('Form errors', form.errors());
    }
};
const plugins = {
    dvr: dvr({
        package: validatorjs
    })
};
const options = {
    validateOnChange: true
};
export default new MobxReactForm({ fields }, { hooks, plugins, options });
/* eslint-enable */
